module.exports = __webpack_public_path__ + "img/btn_ASR_pressed.13728efd.png";